import React, { useContext } from "react";
import { Container } from "react-bootstrap";

export default function Footer() {
  const userInfo = JSON.parse(localStorage.getItem("user"));
  const d = new Date();
  return (
    <>
      {userInfo ? (
        <Container fluid className="p-0 mt-auto">
          <footer className="text-center">
            <strong>
              Copyright © 2014-{`${d.getFullYear()} `}
              <a href="https://www.emadiappraisals.com/">Emadi Appraisals</a>.{" "}
            </strong>
            All rights reserved.
          </footer>
        </Container>
      ) : (
        <></>
      )}
    </>
  );
}
